import { reportSchema } from '@billing/validation/report';
import { MRT_Row, MRT_TableInstance } from 'mantine-react-table';
import { Provider } from './provider';
import { Remittance } from './remittance';
import { User } from './user';

export interface Report {
  // required fields
  id: string;
  createdAt: string;
  type: string;
  s3Path: string;
  userID?: string;
  cognitoID: string | null;
  siteID: string;
  status: string;

  // optional fields
  userEmail?: string;
  providerID?: string | null;
  tariffID?: string;
  tariffIDs?: string[];
  patientID?: string;
  submissionID?: string;
  remittanceID?: string;
  startDate?: string;
  endDate?: string;
  payorID?: string[];
  groupIDs?: string[];
  groupName?: string;
  reportScope?: 'provider' | 'group' | 'site';
  user?: User;
  headers?: string[];
  dateType?: 'serviceDate' | 'paymentDate';
  exportType?: 'pdf' | 'csv';
  subtype?: string;
}

export interface ReportModalProps {
  row: MRT_Row<Report>;
  table: MRT_TableInstance<Report>;
  providers: Provider[];
  remittances?: Remittance[];
  internalEditComponents?: React.ReactNode[];
}

export interface CustomReportColumnStates {
  date: boolean;
  eob: boolean;
  billedAmount: boolean;
  paidAmount: boolean;
  payor: boolean;
  site: boolean;
  hospitalName: boolean;
  provider: boolean;
  claimNumber: boolean;
  status: boolean;
  tariff: boolean;
  diagnosis: boolean;
  groupings: boolean;
  patientName: boolean;
  patientDOB: boolean;
  patientPHIN: boolean;
}

export enum ReportType {
  groupIncome = 'groupIncome',
  providerIncome = 'providerIncome',
  statementIncome = 'statementIncome',
  siteIncome = 'siteIncome',
  accountsReceivable = 'accountsReceivable',
  siteReport = 'siteReport',
  providerReport = 'providerReport',
  tariffProviderReport = 'tariffProviderReport',
  customReport = 'customReport',
}

export type FormReport = Omit<Report, 'id' | 'user'>;

export const isReport = (obj: any): obj is Report => {
  return reportSchema.safeParse(obj).success;
};
